<style lang="scss" scoped>
.link {
  cursor: pointer;
}
.male-icon {
  color: $male;
}
.female-icon {
  color: $female;
}
</style>

<template>
  <td v-if="profile" :class="{ 'table-deleted': profile.deleted_at !== null }">
    <router-link :to="link">
      <img height="45" width="45" class="rounded-circle mr-2 link" :src="src" />
      {{ profile.name }}
      <i v-if="profile.sex == 'männlich'" class="fas fa-mars male-icon"></i>
      <i
        v-else-if="profile.sex == 'weiblich'"
        class="fas fa-venus female-icon"
      ></i>
    </router-link>
  </td>
  <td v-else v-html="nullHtml"></td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
    props: ['model', 'content'],
    computed: {
      src () {
        return this.profile.primary_image === undefined ? '' : `${this.profile.primary_image.url}?width=45&height=45`;
      },
      link () {
        if (this.profile.type == 1) {
          return `/fake/kartei/${this.profile.id}`;
        }
        return `/mitglieder/kartei/${this.profile.id}`;
      },
      profile () {
        return (this.content !== null && typeof this.content === 'object')
          ? this.content
          : (this.model.sex !== undefined ? this.model : null);
      },
      nullHtml() {
        return defaultNullHtml();
      },
    }
};
</script>
